/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

module.exports = {
    AUDIO_TYPES: {
        1: 'mp2a',
        2: 'mp3',
        3: 'AC3',
        4: 'AAC',
        5: 'PCM',
        6: 'OGG',
        7: 'DTS'
    },
    LANGUAGES: {
        rus: 'Russian',
        eng: 'English',
        und: ' '
    },
    aspects: {
        0: 'Original',
        1: 'Letter box',
        2: 'Pan&Scan',
        3: 'combined',
        4: 'enlarged',
        5: 'optimal'
    }
};
